<div class="flex h-full rounded-lg flex-col lg:flex-row justify-between bg-primary-custom">
    <div  class="p-3 cursor-pointer absolute top-2 right-2" (click)="closeModal()">
        <span class="text-white lg:text-black">
            <i class="ico-Close"></i>
        </span>
    </div>
    <div class="lg:w-1/2 flex flex-col justify-center w-full lg:h-full lg:order-1 order-3 bg-white rounded-t-3xl lg:rounded-none">

<!-- lg:w-1/2 -->

        <ng-container [ngSwitch]="itemStep">

            <ng-container *ngSwitchCase="'step-register'">
                <iho-register (phoneNumberChange)="phoneNumberChange($event)"
                    (emitActivationCode)="emitActivationCode($event)"></iho-register>
            </ng-container>


            <ng-container *ngSwitchCase="'step-otp'">
                <iho-otp-stepper 
                [maxTime]="responseActivationCode.ActivationCodeExpireDate"
                [responseActivationCode]="responseActivationCode"
                (emitModelVerify)="emitModelVerify($event)" 
                [phoneNumber]="EmailMobile ? EmailMobile : phoneNumber"
                [isForgetPass]="isForgetPass"
                (status)="status($event)"></iho-otp-stepper>
            </ng-container>


            <ng-container *ngSwitchCase="'step-login-user'">
                <iho-login-user (status)="status($event)"></iho-login-user>
            </ng-container>
            <ng-container *ngSwitchCase="'step-new-pass'">
                <iho-new-pass (status)="status($event)" 
                [phoneNumber]="EmailMobile ? EmailMobile : phoneNumber"
                [ModelVerify]="ModelVerify" />
            </ng-container>


            <ng-container *ngSwitchCase="'step-forget-pass'">
                <iho-forget-pass (status)="status($event)"
                (emitActivationCode)="emitActivationCode($event)"
                (emitEmailMobile)="emitEmailMobile($event)" />
            </ng-container>

        </ng-container>
        <div class="w-full text-center mt-4 px-5 pb-4" 
            *ngIf="itemStep !== 'step-login-user' && itemStep !== 'step-forget-pass' && itemStep !== 'step-new-pass'">
            
            <button mat-button color="primary" 
            (click)="itemStep = 'step-login-user'" 
            class="text-blue-500 cursor-pointer !text-base !h-11 w-full">
            ورود با نام کاربری
            </button>
        </div>
        <div class="w-full text-center mt-4 px-5 pb-4" 
        *ngIf="itemStep === 'step-login-user' || itemStep === 'step-forget-pass'">
            <button mat-button color="primary" (click)="itemStep = 'step-register'"
             class="text-blue-500 cursor-pointer !text-base !h-11 w-full">ورود با کد تایید
            </button>
        </div>





    </div>
    <div
        class="bg-primary-custom flex flex-col justify-center items-center lg:w-1/2 h-1/2 lg:h-full w-full lg:order-2 order-1">
        <h3 class="text-white mb-3 font-bold">رویاتو سفرکن!</h3>
        <img [src]=" cdnUrl + '/images/modal.png'" class="object-contain">
    </div>

</div>